import axios from "axios";

const instance = axios.create({
    baseURL: 'https://us-central1-amzhtw.cloudfunctions.net/api' //'http://localhost:5001/amzhtw/us-central1/api' //The api (cloud function URL)
});

export default instance;